import React from 'react';

import classNames from 'classnames';

import { endWithDot } from '@app/common/utils/string/string';

import styles from './PolicyTitle.pcss';

export interface PolicyTitleProps {
  title: string;
  status?: 'default' | 'valid' | 'invalid';
}

export const PolicyTitle: React.FC<PolicyTitleProps> = React.memo(({ title, status }) => (
  <span
    data-stable-name="PolicyTitle"
    className={classNames(
      styles.title,
      status === 'valid' && styles.titleValid,
      status === 'invalid' && styles.titleInvalid,
    )}
    // For screen readers we have some pronounce suspend bettwen items.
    // So we add a dot to end the sentence.
    aria-label={endWithDot(title)}
  >
    {title}
  </span>
));
